import { useState } from "react"

import { Button, Drawer } from "@mui/material"
import MenuIcon from '@mui/icons-material/Menu';

import NavList from './NavList'

/*
* contain the menu button icon and Drawer for mobile devices
*/
const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = (forceValue) => () => {
    setMenuOpen(forceValue === undefined ? !menuOpen : forceValue)
  }

  return (
    <>
      <Button
        variant="text"
        onClick={toggleMenu(true)}
        sx={{ display: { xs: 'flex', sm: 'none'}}}>
        <MenuIcon />
      </Button>
      <Drawer
        anchor="right"
        open={menuOpen}
        onClose={toggleMenu(false)}
        sx={{ display: { xs: 'inherit', sm: 'none'}}}>
        <NavList onLinkClicked={toggleMenu(false)}/>
      </Drawer>
      <NavList sx={{ display: { xs: 'none', sm: 'inherit'}}} />
    </>
  )

}

export default Nav